import { formatDate, IDeaRegistration, mailTo } from '../common';
import { replace as lreplace } from 'lodash/fp';

export const show = (value: keyof IDeaRegistration) => (a: IDeaRegistration) =>
  value === 'busAddress' || value === 'orgAddress'
    ? mailTo(a[value])
    : value === 'expDt' || value === 'appStatusDt' || value === 'provisionDt'
    ? formatDate(a[value])
    : value === 'regStatus'
    ? a['regStatus'] === 'EXPIRED' ? lreplace(/_/g, ' ')(a[value]) : lreplace(/_/g, ' ')(a[value] + '_' + a['certStatus'])
    : a[value];
